module.exports = __webpack_public_path__ + "img/logo2a.f352c3b6.png";